module.exports = __webpack_public_path__ + "img/syncLoading.85d290ae.svg";